import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { auth, db } from "@/firebase";
import { signInWithPhoneNumber, ConfirmationResult, RecaptchaVerifier } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { sanitizePhone } from "@/utils/phones";

// Global storage for non-serializable Firebase object
let confirmationResult: ConfirmationResult | null = null;

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fakeBaseQuery(),
  endpoints: (builder) => ({
    sendOtp: builder.mutation<{ success: boolean }, { phone: string; verifier: RecaptchaVerifier }>({
      async queryFn({ phone, verifier }) {
        try {
          confirmationResult = await signInWithPhoneNumber(auth, phone, verifier);
          return { data: { success: true } };
        } catch (error: any) {
          return { 
            error: { 
                status: 'CUSTOM_ERROR',
                error: error.message || "Error al enviar SMS" 
            } 
          };
        }
      },
    }),
    confirmOtp: builder.mutation<{ uid: string; phone: string | null }, { code: string }>({
      async queryFn({ code }) {
        try {
          if (!confirmationResult) {
            throw new Error("No se encontró el resultado de confirmación. Intenta de nuevo.");
          }
          const result = await confirmationResult.confirm(code);
          const user = result.user;

          // Sync with Firestore profile
          const docRef = doc(db, `users/${user.uid}`);
          const userDoc = await getDoc(docRef);

          if (!userDoc.exists()) {
            await setDoc(docRef, {
              uid: user.uid,
              phone: sanitizePhone(user.phoneNumber ?? ""),
              createdAt: Date.now(),
              role: "customer",
            });
          }

          return { data: { uid: user.uid, phone: sanitizePhone(user.phoneNumber ?? "") } };
        } catch (error: any) {
          return { 
            error: { 
                status: 'CUSTOM_ERROR',
                error: error.message || "Código inválido o expirado" 
            } 
          };
        }
      },
    }),
  }),
});

export const { useSendOtpMutation, useConfirmOtpMutation } = authApi;
